import { inject, Injectable } from '@angular/core';
import { ExternalPermissionObserverClient, ExternalPermissionResponse } from '../../core/openapi/bff-user-portal';
import { BehaviorSubject, Observable, tap } from 'rxjs';

export type ObserverApiKey = string;
export type ObserverPermissions = ExternalPermissionResponse[] | null;

@Injectable({
  providedIn: 'root',
})
export class ObserverAuthService {
  private readonly permissionService = inject(ExternalPermissionObserverClient);

  private readonly _permissions$: BehaviorSubject<ObserverPermissions> = new BehaviorSubject<ObserverPermissions>(null);
  public readonly permissionsStream$: Observable<ObserverPermissions> = this._permissions$.asObservable();

  public get permissions(): ObserverPermissions {
    return this._permissions$.getValue();
  }

  private _apiKey: ObserverApiKey = '';

  public get apiKey(): ObserverApiKey {
    return this._apiKey;
  }

  public loadPermissions(
    apiKey: ObserverApiKey,
  ): Observable<ExternalPermissionResponse[]> {
    this.setApiKey(apiKey);

    return this.permissionService
      .observerV1ExternalPermissionGet()
      .pipe(tap((permissions) => this.setObserverPermissions(permissions)));
  }

  private setApiKey(value: ObserverApiKey): void {
    this._apiKey = value;
  }

  private setObserverPermissions(value: ObserverPermissions): void {
    this._permissions$.next(value);
  }
}
